import Axios from "axios";
import { message } from "antd";

export default function postCompanyAccount( id,required,cb) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/add-account-number`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: {
        id,
        required,
        printed:true
      },
    })
      .then((response) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
        window.location.reload();
      })
      .catch((err) => {
        message.error("Something Went Wrong Please try again Later");
        dispatch({
          type: "Loading",
          payload: false,
        });
      });
  };
}
